<template>
  <div class="pa-4 grey lighten-5">
    <v-row dense>
      <v-col cols="12" md="7">
        <div class="caption grey--text font-weight-black text-uppercase mb-1">
          Guía de despacho <span v-if="item.folio">N° {{ item.folio }}</span><span v-else>(borrador)</span>
        </div>
        <table class="preview-kv">
          <tr><td>Receptor</td><td><b>{{ customer && customer.name }}</b> · {{ customer && customer.rut }}</td></tr>
          <tr><td>Dirección</td><td>{{ item.address || 'Dirección del cliente' }}</td></tr>
          <tr>
            <td>Comuna</td>
            <td>
              <span v-if="item.comuna">{{ item.comuna }}</span>
              <span v-else>{{ defaultComuna || '—' }} <span class="grey--text caption">(del cliente)</span></span>
            </td>
          </tr>
          <tr><td>Observaciones</td><td>Local {{ item.local_code }} - {{ item.local_name }}</td></tr>
        </table>
      </v-col>
      <v-col cols="12" md="5">
        <table class="preview-kv">
          <tr><td>Fecha</td><td>{{ p.fecha || 'Fecha de emisión' }}</td></tr>
          <tr><td>Traslado</td><td>{{ trasladoText }}</td></tr>
          <tr><td>Despacho</td><td>{{ despachoText }}</td></tr>
          <tr v-if="p.oc_folio"><td>Referencia</td><td>OC {{ p.oc_folio }}<span v-if="p.oc_fecha"> del {{ p.oc_fecha }}</span></td></tr>
          <tr v-if="transporteText"><td>Transporte</td><td>{{ transporteText }}</td></tr>
        </table>
      </v-col>
    </v-row>

    <v-simple-table dense class="mt-3 transparent">
      <thead>
        <tr>
          <th class="text-left">Producto</th>
          <th class="text-right" style="width: 90px">Cantidad</th>
          <th class="text-right" style="width: 110px">Precio unit.</th>
          <th class="text-right" style="width: 110px">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(line, i) in rows" :key="i">
          <td class="text-left">
            <div class="body-2">{{ line.name }}</div>
            <div v-if="line.description && line.description !== line.name" class="caption grey--text">{{ line.description }}</div>
          </td>
          <td class="text-right">{{ line.qty }}</td>
          <td class="text-right">{{ money(line.price, 2) }}</td>
          <td class="text-right">{{ money(Math.round(line.qty * line.price), 0) }}</td>
        </tr>
        <tr v-if="!emitted">
          <td colspan="4" class="caption grey--text text-left">Precio neto vigente en la cotización; se toma al emitir.</td>
        </tr>
      </tbody>
      <tfoot>
        <tr><td colspan="3" class="text-right caption">Neto</td><td class="text-right">{{ neto | currency('$', 0, { thousandsSeparator: '.' }) }}</td></tr>
        <tr><td colspan="3" class="text-right caption">IVA ({{ ivaRate }}%)</td><td class="text-right">{{ iva | currency('$', 0, { thousandsSeparator: '.' }) }}</td></tr>
        <tr><td colspan="3" class="text-right caption font-weight-bold">Total</td><td class="text-right font-weight-bold">{{ (neto + iva) | currency('$', 0, { thousandsSeparator: '.' }) }}</td></tr>
      </tfoot>
    </v-simple-table>
  </div>
</template>

<script>
const TRASLADOS = {
  1: 'Operación constituye venta', 2: 'Ventas por efectuar', 3: 'Consignaciones', 4: 'Entrega gratuita',
  5: 'Traslados internos', 6: 'Otros traslados no venta', 7: 'Guía de devolución',
}
const DESPACHOS = {
  1: 'Por cuenta del receptor', 2: 'Por cuenta del emisor a cliente', 3: 'Por cuenta del emisor a otras instalaciones',
}

export default {
  name: 'BulkDispatchGuidePreview',
  props: {
    item: { type: Object, required: true },
    params: { type: Object, default: () => ({}) },
    customer: { type: Object, default: null },
    defaultComuna: { type: String, default: null },
    prices: { type: Object, default: () => ({}) }, // {key: precio neto unitario vigente}
  },
  methods: {
    money(n, decimals) {
      return '$' + Number(n || 0).toLocaleString('es-CL', { maximumFractionDigits: decimals })
    },
  },
  computed: {
    p() { return this.params || {} },
    emitted() { return !!(this.item.document_lines && this.item.document_lines.length) },
    rows() {
      // Emitida: lo que se envió a Facturación.cl; pendiente: precio vigente de la cotización por key
      if (this.emitted) return this.item.document_lines.map(l => ({ ...l, price: Number(l.price || 0) }))
      return (this.item.lines || []).map(l => ({ ...l, price: Number(this.prices[l.key] || 0) }))
    },
    ivaRate() {
      const tax = this.$store.getters.getCompany && this.$store.getters.getCompany.tax
      return tax !== undefined && tax !== null ? Number(tax) : 19
    },
    neto() { return this.rows.reduce((acc, l) => acc + Math.round(Number(l.qty || 0) * l.price), 0) },
    iva() { return Math.round(this.neto * this.ivaRate / 100) },
    trasladoText() { const v = this.p.tipo_traslado || 1; return v + ' - ' + (TRASLADOS[v] || '') },
    despachoText() { const v = this.p.tipo_despacho || 1; return v + ' - ' + (DESPACHOS[v] || '') },
    transporteText() {
      const t = this.p.transporte || {}
      return [t.patente && 'Patente ' + t.patente, t.nombre_chofer && 'Chofer ' + t.nombre_chofer, t.rut_trans && 'RUT trans. ' + t.rut_trans]
        .filter(Boolean).join(' · ')
    },
  },
}
</script>

<style scoped>
.preview-kv td { padding: 2px 12px 2px 0; vertical-align: top; font-size: 13px; }
.preview-kv td:first-child { color: #888; white-space: nowrap; }
</style>
